import styled from 'styled-components';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import { DROPDOWN_ITEM_DEFAULT_HEIGHT, SELECTABLE_BUTTON_MAX_WIDTH } from 'HubStyleTokens/sizes';
import UIList from 'UIComponents/list/UIList';
// @ts-expect-error module is not typed
import DropdownMenuOption from 'UIComponents/dropdown/internal/DropdownMenuOption';
import { BASE_FONT_COLOR } from 'HubStyleTokens/theme';
import { WEB_FONT_REGULAR_WEIGHT } from 'HubStyleTokens/misc';
import Small from 'UIComponents/elements/Small';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { getFromNumberDescription } from 'calling-ui-library/utils/phoneNumberSourceUtils';
import { useCallFromNumberContext } from '../contexts/CallFromNumberContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MAX_OPTIONS = 4;
const StyledUIList = styled(UIList).withConfig({
  displayName: "CallFromNumberOptions__StyledUIList",
  componentId: "x8v9zg-0"
})(["overflow-y:auto;max-height:calc((", " + 0.5) * ", ");"], MAX_OPTIONS, DROPDOWN_ITEM_DEFAULT_HEIGHT);
const StyledDropdownMenuOption = styled(DropdownMenuOption).withConfig({
  displayName: "CallFromNumberOptions__StyledDropdownMenuOption",
  componentId: "x8v9zg-1"
})(["width:100%;cursor:pointer;&&{min-width:", ";color:", ";font-weight:", ";}&&:hover{color:", ";text-decoration:none;}&:hover{background-color:", ";}"], SELECTABLE_BUTTON_MAX_WIDTH, BASE_FONT_COLOR, WEB_FONT_REGULAR_WEIGHT, BASE_FONT_COLOR, CALYPSO_LIGHT);
const CallFromNumberOptions = ({
  onSelect
}) => {
  const {
    selectedFromNumber,
    hubspotProvidedNumbers
  } = useCallFromNumberContext();
  return /*#__PURE__*/_jsx(StyledUIList, {
    children: hubspotProvidedNumbers && hubspotProvidedNumbers.map((hubspotProvidedNumber, index) => {
      const nickname = hubspotProvidedNumber.get('nickname');
      const source = hubspotProvidedNumber.get('source');
      const phoneNumber = hubspotProvidedNumber.get('phoneNumber');
      const extension = hubspotProvidedNumber.get('extension');
      const friendlyName = hubspotProvidedNumber.get('friendlyName') || '';
      const selected = selectedFromNumber && friendlyName === selectedFromNumber.get('friendlyName');
      return /*#__PURE__*/_jsx(StyledDropdownMenuOption, {
        selected: selected,
        onClick: () => onSelect(hubspotProvidedNumber),
        "data-selenium-test": `call-from-number-option-${index}`,
        children: nickname ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: nickname
          }), /*#__PURE__*/_jsxs(Small, {
            className: "display-block",
            children: [/*#__PURE__*/_jsx(FormattedPhoneNumber, {
              value: phoneNumber,
              extension: extension || ''
            }), ' ', "(", getFromNumberDescription(source), ")"]
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedPhoneNumber, {
            value: phoneNumber,
            extension: extension || ''
          }), ' ', /*#__PURE__*/_jsx(Small, {
            children: getFromNumberDescription(source)
          })]
        })
      }, index);
    })
  });
};
export default CallFromNumberOptions;